import {EffectsEnum} from "./EffectsEnum.ts";
import {GenerationTypeEnum} from "./GenerationTypeEnum.ts";

export enum InputEnum {
    InitialImage = "InitialImage",
    TextPrompt = "TextPrompt"
}

export interface IInput {
    id: number,
    name: string;
    prompt: string | null
    type: InputEnum;
    placeholder?: string;
    isRequired: boolean;
}

export interface EffectType {
    id: EffectsEnum;
    imgSrc: string | null;
    title: string;
    description: string;
    price: number;
    mediaType: GenerationTypeEnum;
    inputs: IInput[];
    isCustom?: boolean;
}



